// ============================================================================
// TAX PROFILE SERVICE (ADR-0019) — jurisdiction-driven party + service tax data.
// ============================================================================

import { get, put, post } from '../client/axiosClient';
import { taxProfileEndpoints } from '../endpoints/tax.endpoints';
import type {
  ApiResponse, ID,
  PartyTaxProfileDto, UpsertPartyTaxProfileRequest,
  ServiceTaxMappingDto, UpsertServiceTaxMappingRequest, ApplyDefaultMappingResult,
} from '../types';

class TaxProfileService {
  async getPartyProfile(partyId: ID): Promise<PartyTaxProfileDto | null> {
    const r = await get<ApiResponse<PartyTaxProfileDto | null>>(taxProfileEndpoints.partyProfile(partyId));
    return r.data.data ?? null;
  }
  async upsertPartyProfile(partyId: ID, data: UpsertPartyTaxProfileRequest): Promise<PartyTaxProfileDto | null> {
    const r = await put<ApiResponse<PartyTaxProfileDto | null>>(taxProfileEndpoints.partyProfile(partyId), data);
    return r.data.data ?? null;
  }
  async getServiceMapping(serviceId: ID): Promise<ServiceTaxMappingDto | null> {
    const r = await get<ApiResponse<ServiceTaxMappingDto | null>>(taxProfileEndpoints.serviceMapping(serviceId));
    return r.data.data ?? null;
  }
  async upsertServiceMapping(serviceId: ID, data: UpsertServiceTaxMappingRequest): Promise<ServiceTaxMappingDto | null> {
    const r = await put<ApiResponse<ServiceTaxMappingDto | null>>(taxProfileEndpoints.serviceMapping(serviceId), data);
    return r.data.data ?? null;
  }
  /** Live items with no tax master under the entity's jurisdiction (ADR-0047 Phase 2 §7). */
  async getUnmappedServiceCount(): Promise<number> {
    const r = await get<ApiResponse<{ count: number }>>(taxProfileEndpoints.serviceMappingUnmappedCount());
    return r.data.data?.count ?? 0;
  }
  /** Pins every unmapped item to the entity's default tax master (Tax Settings → Defaults). */
  async applyDefaultToUnmapped(): Promise<ApplyDefaultMappingResult> {
    const r = await post<ApiResponse<ApplyDefaultMappingResult>>(taxProfileEndpoints.serviceMappingApplyDefault(), {});
    return r.data.data;
  }
}

export const taxProfileService = new TaxProfileService();
export default taxProfileService;
